// extracted by mini-css-extract-plugin
export default {"productDescription":"raa-z","featuredDescription":"saa-z","description":"taa-z","more":"uaa-z","descriptionSku":"vaa-z"};